async function disableSwipeToClose(data?: any, role?: string) {
    return role !== 'gesture';
}

export { disableSwipeToClose };